import React from 'react'
import {Modal, Form, Select, Input, Button} from 'antd'
import FileField from './FileField'

export interface Item {
  itemNo: string
  description: string
}

export interface FormValues {
  itemNo: string
  cost?: string
  attachment?: string
  quantity?: string
  comment?: string
}

interface Props {
  availableExpenseItems: [Item]
  submitting: boolean
  onClose: () => void
  onSubmit: (values: FormValues) => void
}

function AddInvoiceLineModalForm({
  availableExpenseItems,
  submitting,
  onClose,
  onSubmit,
}: Props) {
  const [form] = Form.useForm()

  function submitValues(values: any) {
    return onSubmit({
      itemNo: values.itemNo,
      cost: values.cost || null,
      quantity: values.quantity || null,
      attachment: values.attachment || null,
      comment: values.comment || null
    })
  }

  function handleSubmit(e: React.FormEvent) {
    form.validateFields()
      .then(values => {
        submitValues(values)
      })
     .catch(info => {})
  }

  return (
    <Modal
      title="Legg til fakturalinje"
      visible={true}
      onOk={handleSubmit}
      okText="Opprett"
      onCancel={() => onClose()}
      okButtonProps={{
        loading: submitting,
      }}
    >
      <div className="add-invoice-line">
        <Form form={form} onFinish={submitValues}>
          <Form.Item
            name="itemNo"
            label="Produkt"
            rules={[{
              required: true,
              message: 'Produkt er påkrevd',
            }]}
          >
            <Select
              style={{width: '100%'}}
              placeholder="Velg produkt"
            >
              {availableExpenseItems.map(({itemNo, description}) => (
                <Select.Option key={itemNo} value={itemNo}>
                  {itemNo} {description}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

         <Form.Item shouldUpdate={(prevValues, curValues) => prevValues.itemNo !== curValues.itemNo}>
          {() => form.getFieldValue('itemNo') === 'FT-007' ? 
            <>
             <Form.Item
                name="quantity"
                label="Antall timer"
                rules={[{
                  required: true,
                  message: 'Antall timer er påkrevd',
                }, 
                { 
                  validator: (_, value) =>  value % 0.25 ? Promise.reject('Tallet må være i hele kvarter') : Promise.resolve()
                }
              ]}
              >
                <Input
                  type="number"
                  step="0.25"
                  min="0.25"
                  placeholder="Antall timer (pr. påbegynte kvarter)"
                />
              </Form.Item>
              <Form.Item 
                name="comment" 
                label="Fritekst"
                rules={[{
                  required: true,
                  message: 'Fritekst er påkrevd'
                }]} 
              >
                <Input.TextArea placeholder="Fritekst (Hva går ekstratjenesten ut på)" />
              </Form.Item>
            </>
          :
            <>
              <Form.Item
                name="cost"
                label="Pris"
                rules={[{
                  required: true,
                  message: 'Pris er påkrevd',
                }]}
              >
                <Input
                  type="number"
                  step=".01"
                  placeholder="Totalpris ink. moms"
                />
              </Form.Item>
              <Form.Item
                name="attachment"
                label="Vedlegg"
                rules={[{
                  required: true,
                  message: 'Vedlegg er påkrevd',
                }]}
              >
                <FileField accept="image/jpeg" />
              </Form.Item>
              <Form.Item 
                name="comment" 
                label="Kommentar"
               >
                <Input.TextArea placeholder="Kommentar" />
              </Form.Item>
            </>
          }
          </Form.Item>
          <Form.Item className="hidden-submit">
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  )
}

export default AddInvoiceLineModalForm
